import './setupPdfjsWorker';
import {loadEnvVars} from './utils/envVars/envVars';

async function bootstrap() {
  try {
    await loadEnvVars();
    await import('./app');
  } catch (error) {
    console.error('Failed to bootstrap application:', error);
    // Optionally display an error message to the user
    throw error;
  }
}

bootstrap().catch((error) => {
  console.error('Unhandled error during bootstrap:', error);
});
